import React from 'react'
import {css, useTheme} from '@emotion/react'
import {Fab, Typography} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import AttachFileIcon from '@mui/icons-material/AttachFile'

import {isImage} from './helpers'


export default function PreviewList({fileObjects, handleRemove, ...props}) {
  const theme = useTheme()
  const styles = {
    root: css`
      display: flex;
      justify-content: center;
    `,
    imageContainer: css`
      position: relative;
      
      z-index: 10;
      
      text-align: center;
      
      &:hover .preview {
        opacity: 0.3;
      }
      
      &:hover .remove-button {
        opacity: 1;
      }
    `,
    image: css`
      height: 80px;
      width: initial;
      
      max-width: 100%;

      color: ${theme.palette.text.primary};
      
      transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
      box-sizing: border-box;
      box-shadow: rgba(0, 0, 0, 0.12) 0 1px 6px, rgba(0, 0, 0, 0.12) 0 1px 4px;
      
      border-radius: 8px;
      z-index: 5;
      opacity: 1;
    `,
    removeButton: css`
      transition: .5s ease;
      position: absolute;
      opacity: 0;
      
      top: -10px;
      right: -10px;
      
      width: 40px;
      height: 40px;
      
      &:focus {
        opacity: 1;
      }
    `,
  }

  const PreviewIcon = ({fileObject}) => {
    if (isImage(fileObject.file)) {
      return (
        /* eslint-disable @next/next/no-img-element */
        <img css={styles.image} className="preview" alt="preview" src={fileObject.data}/>
      )
    }

    return <AttachFileIcon css={styles.image}/>
  }

  return (
    <div css={styles.root} {...props}>
      {fileObjects.map((fileObject, i) => (
        <div key={`${fileObject.file?.name ?? 'file'}-${i}`} css={styles.imageContainer}>
          <PreviewIcon fileObject={fileObject}/>

          <Typography variant="body1" component="p">
            {fileObject.file.name}
          </Typography>

          <Fab css={styles.removeButton} className="remove-button" onClick={handleRemove(i)} aria-label="Delete">
            <DeleteIcon/>
          </Fab>
        </div>
      ))}
    </div>
  )
}
